import { Upload, ScanSearch, SlidersHorizontal, FileDown } from "lucide-react";

const steps = [
  [Upload, "Upload your plan", "Drop a JPG or PNG of your floor plan — a builder brochure or a phone photo works."],
  [ScanSearch, "AI reads every room", "Our vision AI detects rooms, dimensions and carpet area in under a minute."],
  [SlidersHorizontal, "Tailor your package", "Choose Essential, Premium or Luxe, pick rooms and add-ons. Prices update live."],
  [FileDown, "Download your PDF", "Get an itemised, GST-inclusive quotation with timeline and payment schedule."],
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-brand-sand py-20 lg:py-28" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-brand-accent">How it works</p>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-brand-ink mt-4 leading-tight">From blueprint to budget, in four calm steps.</h2>
          </div>
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-6">
            {steps.map(([Icon, t, d], i) => (
              <div key={t} className="group bg-brand-cream rounded-2xl p-8 border border-brand-line hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(43,36,32,0.25)] transition-[transform,box-shadow] duration-300">
                <div className="flex items-center justify-between">
                  <Icon className="w-6 h-6 text-brand-accent" strokeWidth={1.5} />
                  <span className="font-mono-num text-xs text-brand-muted-light">0{i + 1}</span>
                </div>
                <h3 className="font-serif-display text-2xl text-brand-ink mt-8">{t}</h3>
                <p className="text-sm text-brand-muted mt-3 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
